/**
 * Max documents in one Insights import. Each document holds a
 * slot in the org's shared Inngest pool while it processes,
 * so one import must stay small enough to drain in a
 * reasonable time at that concurrency.
 */
export const MAX_INSIGHT_UPLOAD_FILES = 500;

/**
 * Above this many files an import asks for confirmation first:
 * the upload runs in the browser, so the tab has to stay open
 * until every file is sent, and at this size that takes long
 * enough to be worth saying up front.
 */
export const LARGE_INSIGHT_IMPORT_FILES = 100;

/**
 * Documents in one retry-all request. Retries run server-side
 * a few at a time inside the request, so a full import's
 * worth in one call would run into the route's time limit —
 * the client splits larger sets into requests of this size.
 */
export const MAX_INSIGHT_REPROCESS_BATCH = 200;

/** Folder paths one folder-tree request may create. */
export const MAX_INSIGHT_FOLDER_TREE_PATHS = MAX_INSIGHT_UPLOAD_FILES;

/** Durable bucket for Insight document PDFs; browser uploads land here. */
export const INSIGHT_DOCUMENTS_BUCKET = 'insight-documents';

/** Enough for the 5-byte `%PDF-` magic across any reasonable HTTP framing. */
export const PDF_HEADER_PROBE_BYTES = 16;
